<template>
  <CardModule title="Gerenciamento de estoque">
    <v-row>
      <v-col cols="12">
        <v-radio-group
          v-model="
            $produtos_gerenciar.cadastro.dados_cadastrais.gerenciar_estoque
          "
          class="mt-0"
          hide-details
        >
          <v-row>
            <v-col cols="12" class="mt-2">
              <BaseTextField
                persistent-hint
                label="Estoque"
                min="0"
                type="number"
                placeholder="Insira o estoque do produto"
                v-model.number="
                  $produtos_gerenciar.cadastro.dados_cadastrais.estoque
                "
                :hint="stockExplain"
                :required="manageStock"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-radio
                label="Gerenciar estoque"
                :value="1"
                class="rounded-lg pa-2"
                style="border: 1px solid rgb(0 0 0 / 42%)"
                active-class="active-class"
              ></v-radio>
              <v-radio
                label="Vender mesmo sem estoque"
                :value="0"
                class="rounded-lg pa-2"
                style="border: 1px solid rgb(0 0 0 / 42%)"
                active-class="active-class"
              ></v-radio>
            </v-col>
          </v-row>
        </v-radio-group>
      </v-col>
    </v-row>
  </CardModule>
</template>
<script>
import CardModule from "@/components/cards/CardModule.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
export default {
  name: "InventoryManage",
  components: {
    CardModule,
    BaseTextField,
  },
  data: () => ({
    stockExplain:
      "ℹ️ Caso seu produto contenha mais de uma opção, o estoque será somado e apresentado aqui.",
  }),
  computed: {
    manageStock() {
      return (
        this.$produtos_gerenciar.cadastro.variacoes.variacoes_produtos
          .length === 0 &&
        this.$produtos_gerenciar.cadastro.dados_cadastrais.gerenciar_estoque ===
          1
      );
    },
  },
};
</script>
<style scoped>
.active-class {
  background-color: #e6f7ff !important;
  border-color: #91d5ff !important;
  color: #1890ff !important;
}
</style>

<!-- !== IFRAME && LINK -->
